<template>
    <div class="menu-item-spin">
        <div v-if="Summed" class="sum-container" :class=" MenuItem.sum > 0 ? 'visible' : ''">
            <span>{{ (MenuItem.sum  /100 ).toFixed(2) }}р.</span>
        </div>
        <div class="button-container">
            <button v-if="this.MenuItem.qty == 0" @click="inc" class="spin-button">В корзину</button>
            <div v-else>
                <button class="spin-button" @click="dec">-</button>
                <span v-if="(this.MenuItem.rests > 0) && (this.MenuItem.qty > 0)" class="spin-value">{{ MenuItem.qty }} / {{ MenuItem.rests }}</span>
                <span v-else class="spin-value"> {{ MenuItem.qty }} </span>
                <button class="spin-button" @click="inc">+</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['MenuItem', 'Summed'],
    methods:{
        inc: function (){
            if (this.MenuItem.qty){
                if (this.MenuItem.rests < 0) {
                    this.MenuItem.qty += 1
                } else if (((this.MenuItem.rests) - (this.MenuItem.qty + 1)) >= 0) {
                    this.MenuItem.qty += 1
                }
            } else {
                this.MenuItem.qty = 1
            }
            this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
        },
        dec: function (){
            if (this.MenuItem.qty){
                if (this.MenuItem.qty > 0){
                    this.MenuItem.qty -= 1
                }
                this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
            }
        }
    }
}
</script>